
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources",
      function () {
        return require("private-next-pages/resources/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources"])
      });
    }
  